<template>
    <div class="relative w-full">
        <AddTrainingForm v-if="openTrainingFormFlag" @addTrainingsSummaries="addSummariesToMicrocycle" @close="openTrainingFormFlag = false" />
        <div class="flex justify-end px-[30px] mb-[15px]">
            <div @click="$router.push('/training-programs')" class="bg-[#BD9135] mr-[15px] flex justify-center items-center w-[228px] h-[38px] cursor-pointer text-white font-semibold py-[5px] rounded-lg">
                <span>Назад</span>
            </div>
            <div v-if="currentAdminRole != 'supervisor'" @click="saveProgram" class="bg-[#BD9135] flex justify-center items-center w-[228px] h-[38px] cursor-pointer text-white font-semibold py-[5px] rounded-lg">
                <span>Зберегти</span>
            </div>
        </div>
        <div class="flex flex-col items-center">
            <div class="bg-[#DA4167] relative text-white flex justify-center items-center w-[810px] h-[42px] rounded-[6px]" :class="{'border-[1px] border-[#BD9135]' : updateProgramNameFlag}">
                <div class="font-black w-full flex justify-center">
                    <div v-if="updateProgramNameFlag">
                        <input v-model="programStructure.name" class="w-[100%] outline-none bg-transparent text-white text-center" type="text" placeholder="Назва програми">
                    </div>
                    <div class="w-full flex justify-center" v-else>{{ programStructure.name ? programStructure.name : 'Введіть назву програми' }}</div>
                </div>
                <div class="absolute right-[20px]">
                    <svg v-if="updateProgramNameFlag" @click="updateProgramNameFlag = false" class="cursor-pointer" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="13" cy="13" r="13" fill="#339989"/>
                        <line x1="13" y1="5" x2="13" y2="21" stroke="white" stroke-width="2"/>
                        <line x1="5" y1="13" x2="21" y2="13" stroke="white" stroke-width="2"/>
                    </svg>
                    <svg v-else @click="updateProgramNameFlag = true" class="cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 20H21" stroke="#FFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.5 3.49998C16.8978 3.10216 17.4374 2.87866 18 2.87866C18.2786 2.87866 18.5544 2.93353 18.8118 3.04014C19.0692 3.14674 19.303 3.303 19.5 3.49998C19.697 3.69697 19.8532 3.93082 19.9598 4.18819C20.0665 4.44556 20.1213 4.72141 20.1213 4.99998C20.1213 5.27856 20.0665 5.55441 19.9598 5.81178C19.8532 6.06915 19.697 6.303 19.5 6.49998L7 19L3 20L4 16L16.5 3.49998Z" stroke="#FFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div class="mt-[10px] cursor-pointer select-none">
                <svg @click="addSeason()" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="13" cy="13" r="13" fill="#BD9135"/>
                    <line x1="13" y1="5" x2="13" y2="21" stroke="white" stroke-width="2"/>
                    <line x1="5" y1="13" x2="21" y2="13" stroke="white" stroke-width="2"/>
                </svg>
            </div>
        </div>
        <div class="flex w-full justify-center select-none overflow-x-auto">
            <div v-for="season in programStructure.seasons" class="px-[10px]">
                <div class="flex items-center mt-[10px]">
                    <div class="w-[26px]">
                        <svg v-if="season.update" @click="deleteSeason(season)" class="cursor-pointer" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="13" cy="13" r="13" fill="#DA4167"/>
                            <line x1="5" y1="13" x2="21" y2="13" stroke="white" stroke-width="2"/>
                        </svg>
                    </div>
                    <div 
                        @click="() => { selectedSeason = season.id; season.update = true }" 
                        class="cursor-pointer w-[228px] h-[42px] mx-[10px] rounded-[6px] flex px-[20px] items-center relative"
                        :class="{
                            'bg-[#474849] text-[#DA4167]' : selectedSeason === season.id,
                            'bg-[#BD9135] text-white' : selectedSeason != season.id
                        }"    
                    >
                        <!-- <div class="font-black">{{ meso.name }}</div> -->
                        <div class="font-black w-full">
                            <div v-if="season.update">
                                <input 
                                    v-model="season.name" 
                                    class="w-[100%] outline-none bg-transparent text-center"
                                    :class="{
                                        'bg-[#474849] text-[#DA4167]' : selectedSeason === season.id,
                                        'bg-[#BD9135] text-white' : selectedSeason != season.id
                                    }"
                                    type="text" 
                                    placeholder="Назва програми">
                            </div>
                            <div class="w-full flex justify-center" v-else>{{ season.name ? season.name : 'Введіть назву сезона' }}</div>

                            <div class="text-[10px] text-[#FFF] font-normal text-center">
                                (1 МЕЗ 51 МІКР 248 тр)
                            </div>
                        </div>
                    </div>
                    <div class="w-[26px]">
                        <!-- <svg v-if="season.update" @click="season.update = false" class="cursor-pointer mr-4" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="13" cy="13" r="13" fill="#339989"/>
                            <line x1="13" y1="5" x2="13" y2="21" stroke="white" stroke-width="2"/>
                            <line x1="5" y1="13" x2="21" y2="13" stroke="white" stroke-width="2"/>
                        </svg> -->
                        <!-- <svg v-else @click="season.update = true" class="cursor-pointer mr-4" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 20H21" stroke="#FFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M16.5 3.49998C16.8978 3.10216 17.4374 2.87866 18 2.87866C18.2786 2.87866 18.5544 2.93353 18.8118 3.04014C19.0692 3.14674 19.303 3.303 19.5 3.49998C19.697 3.69697 19.8532 3.93082 19.9598 4.18819C20.0665 4.44556 20.1213 4.72141 20.1213 4.99998C20.1213 5.27856 20.0665 5.55441 19.9598 5.81178C19.8532 6.06915 19.697 6.303 19.5 6.49998L7 19L3 20L4 16L16.5 3.49998Z" stroke="#FFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg> -->
                    </div>

                </div>
            </div>
        </div>
        <div v-if="programStructure.seasons?.length" class="mt-[10px] w-full flex justify-center cursor-pointer select-none">
            <svg @click="addMesocycle()" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="13" cy="13" r="13" fill="#339989"/>
                <line x1="13" y1="5" x2="13" y2="21" stroke="white" stroke-width="2"/>
                <line x1="5" y1="13" x2="21" y2="13" stroke="white" stroke-width="2"/>
            </svg>
        </div>
        <div class="flex w-full justify-start select-none overflow-x-auto">
            <div v-for="meso in selectedMesocycles" class="w-[25%] min-w-[300px] px-[10px]">
                <div class="flex flex-col items-center mt-[10px]">
                    
                    <div class="flex items-center">
                        <div class="w-[26px]">
                            <svg v-if="meso.update" @click="deleteMesocycle(meso)" class="cursor-pointer" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="13" cy="13" r="13" fill="#DA4167"/>
                                <line x1="5" y1="13" x2="21" y2="13" stroke="white" stroke-width="2"/>
                            </svg>
                        </div>
                        <div 
                            @click="meso.update = true"
                            class="bg-[#339989] mx-[10px] cursor-pointer text-white w-[228px] px-[20px] h-[42px] rounded-[6px] flex items-center relative"
                            :class="{
                                'bg-[#474849] text-[#DA4167]' : meso.update,
                                'bg-[#339989] text-white' : !meso.update
                            }"       
                            
                        >
                            <!-- <div class="font-black">{{ meso.name }}</div> -->
                            <div class="font-black w-full flex flex-col items-center justify-center">
                                <div v-if="meso.update">
                                    <input 
                                        v-model="meso.name" 
                                        class="w-[100%] text-[13px] pb-[1px] outline-none bg-transparent text-white text-center" 
                                        type="text" 
                                        placeholder="Назва програми"
                                        :class="{
                                            'text-[#DA4167]' : meso.update,
                                            'text-white' : !meso.update
                                        }"    
                                    >
                                </div>
                                <div class="w-full flex justify-center text-[13px]" v-else>{{ meso.name ? meso.name : 'Введіть назву програми' }}</div>

                                <div class="text-[10px] text-[#FFF] font-normal text-center">
                                    (1 МЕЗ 51 МІКР 248 тр)
                                </div>
                            </div>
                        </div>
                        <div class="w-[26px]">
                            <!-- <svg v-if="meso.update" @click="meso.update = false" class="cursor-pointer mr-4" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="13" cy="13" r="13" fill="#339989"/>
                                <line x1="13" y1="5" x2="13" y2="21" stroke="white" stroke-width="2"/>
                                <line x1="5" y1="13" x2="21" y2="13" stroke="white" stroke-width="2"/>
                            </svg> -->
                            <!-- <svg v-else @click="meso.update = true" class="cursor-pointer mr-4" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 20H21" stroke="#FFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.5 3.49998C16.8978 3.10216 17.4374 2.87866 18 2.87866C18.2786 2.87866 18.5544 2.93353 18.8118 3.04014C19.0692 3.14674 19.303 3.303 19.5 3.49998C19.697 3.69697 19.8532 3.93082 19.9598 4.18819C20.0665 4.44556 20.1213 4.72141 20.1213 4.99998C20.1213 5.27856 20.0665 5.55441 19.9598 5.81178C19.8532 6.06915 19.697 6.303 19.5 6.49998L7 19L3 20L4 16L16.5 3.49998Z" stroke="#FFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg> -->
                        </div>
                    </div>

                    <div class="mt-[10px] cursor-pointer">
                        <svg @click="addMicrocycle(meso.id)" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="13" cy="13" r="13" fill="#1B4079"/>
                            <line x1="13" y1="5" x2="13" y2="21" stroke="white" stroke-width="2"/>
                            <line x1="5" y1="13" x2="21" y2="13" stroke="white" stroke-width="2"/>
                        </svg>
                    </div>
                </div>
                <div class="flex flex-col items-center mt-[10px]">
                    <div v-for="micro in getMicroCyclesByMesocycle(meso.id)" @click="() => {openMicrocycle(micro); micro.update = true}" class="relative mb-[10px] text-white py-[10px] rounded-xl flex items-center cursor-pointer">
                        <!-- <div class="font-black">{{ micro.name }}</div> -->
                        <div class="w-[26px]">
                            <svg v-if="micro.update" @click="deleteMicrocycle(micro)" class="cursor-pointer" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="13" cy="13" r="13" fill="#DA4167"/>
                                <line x1="5" y1="13" x2="21" y2="13" stroke="white" stroke-width="2"/>
                            </svg>
                        </div>
                        <div class="font-black mx-[10px] flex flex-col items-center justify-center w-[228px] px-[20px] h-[42px] rounded-[6px]" :class="{'bg-[#474849]' : openMicrocycleObject.id == micro.id, 'bg-[#1B4079]': openMicrocycleObject.id != micro.id}">
                            <div v-if="micro.update">
                                <input 
                                    v-model="micro.name" 
                                    class="w-[100%] outline-none bg-transparent text-center text-[13px]" 
                                    type="text" 
                                    placeholder="Назва мікроцикла"
                                    :class="{
                                        'text-[#DA4167]' : micro.update,
                                        'text-white' : !micro.update
                                    }"       
                                >
                            </div>
                            <div class="w-full flex justify-center text-[13px]" v-else>{{ micro.name ? micro.name : 'Введіть назву програми' }}</div>

                            <div class="text-[10px] text-[#FFF] font-normal text-center">
                                (1 МЕЗ 51 МІКР 248 тр)
                            </div>
                        </div>
                        <div class="w-[26px]">
                            <!-- <svg v-if="micro.update" @click="micro.update = false" class="cursor-pointer mr-4" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="13" cy="13" r="13" fill="#339989"/>
                                <line x1="13" y1="5" x2="13" y2="21" stroke="white" stroke-width="2"/>
                                <line x1="5" y1="13" x2="21" y2="13" stroke="white" stroke-width="2"/>
                            </svg> -->
                            <!-- <svg v-else @click="micro.update = true" class="cursor-pointer mr-4" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 20H21" stroke="#FFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.5 3.49998C16.8978 3.10216 17.4374 2.87866 18 2.87866C18.2786 2.87866 18.5544 2.93353 18.8118 3.04014C19.0692 3.14674 19.303 3.303 19.5 3.49998C19.697 3.69697 19.8532 3.93082 19.9598 4.18819C20.0665 4.44556 20.1213 4.72141 20.1213 4.99998C20.1213 5.27856 20.0665 5.55441 19.9598 5.81178C19.8532 6.06915 19.697 6.303 19.5 6.49998L7 19L3 20L4 16L16.5 3.49998Z" stroke="#FFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div v-if="openMicrocycleModalFlag && programId" class=" w-[90%] mx-auto mt-3 mb-5 rounded-[10px] overflow-x-auto">
            <div class="mb-[20px] flex justify-end">
                <div v-if="currentAdminRole != 'supervisor'" @click="openTrainingFormFlag = true" class="bg-[#BD9135] flex justify-center items-center w-[228px] h-[38px] cursor-pointer text-white font-semibold py-[5px] rounded-lg">
                    <span>Додати тренування</span>
                </div>
            </div>
            <!-- <table class="w-full">
                <thead class="text-white select-none">
                    <tr class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                        <th class="px-3 py-2 w-[5%] text-center font-bold text-sm"></th>
                        <th class="px-3 py-2 w-[20%] text-start font-bold text-sm">Назва тренування</th>
                        <th class="px-3 py-2 w-[16.6%] text-start font-bold text-sm">Вікова категорія</th>
                        <th class="px-3 py-2 w-[16.6%] text-start font-bold text-sm">Направленість</th>
                        <th class="px-3 py-2 w-[16.6%] text-start font-bold text-sm">МЕЗО</th>
                        <th class="px-3 py-2 w-[16.6%] text-start font-bold text-sm">МІКРО</th>
                        <th class="px-3 py-2 w-[16.6%] text-start font-bold text-sm"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="currentMicrocycleSummaries.length > 0" v-for="summary in currentMicrocycleSummaries" class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                        <td @click="$router.push('/training-summary/' + summary.summary_id)" class="cursor-pointer px-3 py-2 w-[5%] text-center font-medium text-sm">
                            <div class="rounded-full border-[1px] bg-[#BD9135] border-white w-[50px] h-[50px] flex justify-center items-center text-center align-middle">
                                <span class="text-[18px]">{{ summary.name[0] }}</span>
                            </div>
                        </td>
                        <td @click="$router.push('/training-summary/' + summary.summary_id)" class="cursor-pointer px-3 py-2 w-[16.6%] text-start font-bold text-sm">{{ summary.name }}</td>
                        <td class="px-3 py-2 w-[16.6%] text-start font-bold text-sm">{{ parseAgeGroup(summary.age_group) }}</td>
                        <td class="px-3 py-2 w-[16.6%] text-start font-bold text-sm">{{ parseElementDirection(summary.direction) }}</td>
                        <td class="px-3 py-2 w-[16.6%] text-start font-bold text-sm">{{ summary.mesocycle_name }}</td>
                        <td class="px-3 py-2 w-[16.6%] text-start font-bold text-sm">{{ summary.microcycle_name }}</td>
                        <td class="px-3 w-[16.6%] py-2 text-start font-bold text-sm">
                            <img v-if="currentAdminRole != 'supervisor'" @click="removeSummary(summary)" class="cursor-pointer" src="@/assets/icons/circle_minus_icon.svg"/>
                        </td>
                    </tr>

                    <tr v-else>
                        <td colspan="5" class="text-center text-white pt-[15px]">Конспекти відсутні</td>
                    </tr>
                </tbody>
            </table> -->

            <TableWrapper>
                <TableComponent :fullWidth="true">
                    <TableHeader>
                        <TableHeaderRow>
                            <TableHeaderCell
                                value=""
                                :width="50"
                                :textStart="true"
                            />
                            <TableHeaderCell
                                value="Назва тренування"
                                :width="100"
                                :textStart="true"
                            />
                            <TableHeaderCell
                                value="Вікова категорія"
                                :width="200"
                                :textStart="true"
                            />
                            <TableHeaderCell value="Направленість" :width="100" />
                            <TableHeaderCell value="МЕЗО" :width="100" />
                            <TableHeaderCell value="МІКРО" :width="100" />
                            <TableHeaderCell value="" :width="100" />
                        </TableHeaderRow>
                    </TableHeader>
                    <TableBody>
                        <TableRow v-if="currentMicrocycleSummaries.length > 0" v-for="summary in currentMicrocycleSummaries">
                            <TableCell :asChild="true" :width="50">
                                <div class="rounded-full border-[1px] bg-[#BD9135] border-white w-[50px] h-[50px] flex justify-center items-center text-center align-middle">
                                    <span class="text-[18px]">{{ summary.name[0] }}</span>
                                </div>
                            </TableCell>
                            <TableCell :asChild="true">
                                <div @click="$router.push('/training-summary/' + summary.summary_id)" class="cursor-pointer px-3 py-2 text-start font-bold text-sm">
                                    {{ summary.name }}
                                </div>
                            </TableCell>
                            <TableCell :asChild="true">
                                <div class="w-full h-full flex justify-center">
                                    {{ parseAgeGroup(summary.age_group) }}
                                </div>
                            </TableCell>
                            <TableCell :asChild="true">
                                <div class="flex gap-[10px]">
                                    <div v-for="or in summary.trainingOrientation" :style="[`background-color: ${or.color}; width: max-content;`]" class="rounded-[6px] text-white text-[12px] px-[10px] py-[3px]">
                                        {{ or.name }} ({{ or.averagePercent.toFixed(2) }})
                                    </div>
                                </div>
                            </TableCell>
                            <TableCell :asChild="true">
                                <div class="cursor-pointer w-[100%] z-[-40] flex justify-center">

                                    {{ summary.mesocycle_name }}

                                </div>
                            </TableCell>
                            <TableCell :asChild="true">
                                <div class="cursor-pointer w-[100%] z-[-40] flex justify-center">

                                    {{ summary.microcycle_name }}

                                </div>
                            </TableCell>
                            <TableCell :asChild="true" :text-end="true">
                                <div class="flex justify-end">
                                     <img v-if="currentAdminRole != 'supervisor'" @click="removeSummary(summary)" class="cursor-pointer" src="@/assets/icons/circle_minus_icon.svg"/>
                                </div>
                            </TableCell>
                        </TableRow>
                        <tr v-else>
                            <td colspan="7" class="text-center text-white pt-[15px]">Конспекти відсутні</td>
                        </tr>
                    </TableBody>
                </TableComponent>
            </TableWrapper>
        </div>
    </div>
</template>

<script>
    import { ref, onMounted, watch } from 'vue'
    import { useRoute } from 'vue-router'
    import { uuid } from 'vue3-uuid'
    import { getSummariesByMicrocycleId, addSummaryToProgram } from '@/services/apiRequests'
    import AddTrainingForm from './components/AddTrainingForm.vue'

    export default {
        name: 'TrainingProgramView',

        props: {
            program: {
                type: Object,
                default: () => ({})
            }
        },

        setup(props, { emit }) {
            const programStructure = ref({
                name: props.program?.name ? props.program?.name : '',
                description: props.program?.description ? props.program?.description : '',
                age_group: props.program?.age_group ? props.program?.age_group : '',
                mesocycles: props.program?.mesocycles ? props.program?.mesocycles.map(e => ({
                    ...e,
                    update: false
                })) : [],
                microcycles: props.program?.microcycles ? props.program?.microcycles.map(e => ({
                    ...e,
                    update: false
                })) : [],
                seasons: props.program?.seasons ? props.program?.seasons : [],
                groups: props.program?.groups ? props.program?.groups : []
            })

            const updateProgramNameFlag = ref(false) 

            const selectedSeason = ref('')

            const openMicrocycleModalFlag = ref(false)
            const openMicrocycleObject = ref({})

            const currentMicrocycleSummaries = ref([])
            const openTrainingFormFlag = ref(false)

            const route = useRoute()
            const programId = route.params.id

            const getMicroCyclesByMesocycle = (mesocycleId) => {
                return programStructure.value.microcycles.filter(microcycle => microcycle.mesocycle_id === mesocycleId)
            }

            const addMicrocycle = (mesocycleId) => {
                const countMicrocycles = programStructure.value.microcycles.filter(microcycle => microcycle.mesocycle_id === mesocycleId).length
                // if (countMicrocycles < 4) {
                const newMicrocycle = {
                    id: uuid.v4(),
                    name: `Мікроцикл ${countMicrocycles + 1}`,
                    mesocycle_id: mesocycleId
                }
                programStructure.value.microcycles.push(newMicrocycle)
                // }
            }

            const addMesocycle = () => {
                // if (programStructure.value.mesocycles.length < 4) {
                const newMesocycle = {
                    id: uuid.v4(),
                    name: `Мезоцикл ${programStructure.value.mesocycles.length + 1}`,
                    season_id: selectedSeason.value
                }
                programStructure.value.mesocycles.push(newMesocycle)
                updateMesocycles()
                // } 
            }

            const addSeason = () => {
                const newSeason = {
                    id: uuid.v4(),
                    name: `Сезон ${programStructure.value.seasons.length + 1}`
                }
                programStructure.value.seasons.push(newSeason)
                selectedSeason.value = newSeason.id
            }

            const saveProgram = () => {
                emit('saveProgram', programStructure.value)
            }

            const openMicrocycle = async (microcycle) => {
                openMicrocycleObject.value = microcycle
                openMicrocycleModalFlag.value = true

                const result = await getSummariesByMicrocycleId(microcycle.id)
                currentMicrocycleSummaries.value = result
            }

            const selectedMesocycles = ref([])

            const updateMesocycles = () => {
                selectedMesocycles.value = programStructure.value.mesocycles.filter(mesocycle => mesocycle.season_id === selectedSeason.value)
            }

            watch(selectedSeason, async (newSeason) => {
                updateMesocycles()
            })

            const addSummariesToMicrocycle = async (summaries) => {
                for (let i = 0; i < summaries.length; i++) {
                    const summary = summaries[i]

                    const mesocycleObject = programStructure.value.mesocycles.find(mesocycle => mesocycle.id === openMicrocycleObject.value.mesocycle_id)
                    const microcycleObject = programStructure.value.microcycles.find(microcycle => microcycle.id === openMicrocycleObject.value.id)
                    const programObject = {
                        id: props.program.id,
                        name: props.program.name,
                        description: props.program.description,
                        age_group: props.program.age_group,
                        mesocycles: programStructure.value.mesocycles,
                        microcycles: programStructure.value.microcycles,
                        groups: programStructure.value.groups
                    }

                    await addSummaryToProgram(
                        programObject.id, 
                        programObject.name,
                        microcycleObject.id,
                        microcycleObject.name,
                        mesocycleObject.id,
                        mesocycleObject.name, 
                        summary.summary_id)
                }

                const result = await getSummariesByMicrocycleId(openMicrocycleObject.value.id)
                currentMicrocycleSummaries.value = result
                openTrainingFormFlag.value = false
            }

            const removeSummary = async (summary) => {
                await addSummaryToProgram(
                    '', 
                    '',
                    '',
                    '',
                    '',
                    '', 
                    summary.summary_id)
                openTrainingFormFlag.value = false

                const result = await getSummariesByMicrocycleId(openMicrocycleObject.value.id)
                currentMicrocycleSummaries.value = result
            }

            onMounted(() => {
                console.log('TrainingProgramView mounted')
                console.log('programStructure ----> ', programStructure.value)
            })

            const parseAgeGroup = (ageGroup) => {
                if (!ageGroup) return '—'
                if (typeof ageGroup === 'string' && ageGroup.endsWith('_years')) {
                    return ageGroup.split('_')[0] + ' років'
                }
                if (ageGroup === 'main_team') return 'Основна команда'
                return ageGroup
            }

            const parseElementDirection = (direction) => {
                switch (direction) {
                    case 'physical':
                        return 'Фізичне'
                    case 'tactical':
                        return 'Тактичне'
                    case 'technical':
                        return 'Технічне'
                    case 'tech_tactical':
                        return 'Техніко/тактичне'
                    default:
                        return 'Невідома направленість'
                }
            }

            const currentAdminRole = ref(localStorage.getItem('userType'))

            const deleteMesocycle = (meso) => {
                programStructure.value.mesocycles = programStructure.value.mesocycles.filter(m => m.id !== meso.id)
                programStructure.value.microcycles = programStructure.value.microcycles.filter(m => m.mesocycle_id !== meso.id)
                selectedMesocycles.value = programStructure.value.mesocycles.filter(m => m.season_id === selectedSeason.value)
            }

            const deleteMicrocycle = (micro) => {
                programStructure.value.microcycles = programStructure.value.microcycles.filter(m => m.id !== micro.id)
                currentMicrocycleSummaries.value = currentMicrocycleSummaries.value.filter(m => m.microcycle_id !== micro.id)
            }

            const deleteSeason = (season) => {
                programStructure.value.seasons = programStructure.value.seasons.filter(s => s.id !== season.id)
                programStructure.value.mesocycles = programStructure.value.mesocycles.filter(m => m.season_id !== season.id)
                programStructure.value.microcycles = programStructure.value.microcycles.filter(m => m.season_id !== season.id)
                selectedMesocycles.value = programStructure.value.mesocycles.filter(m => m.season_id === selectedSeason.value)
            }

            return {
                programStructure,
                getMicroCyclesByMesocycle,
                addMicrocycle,
                addMesocycle,
                updateProgramNameFlag,
                openMicrocycleModalFlag,
                openMicrocycleObject,
                openMicrocycle,
                saveProgram,
                currentMicrocycleSummaries,
                openTrainingFormFlag,
                addSummariesToMicrocycle,
                removeSummary,
                programId,
                addSeason,
                selectedSeason,
                selectedMesocycles,
                parseAgeGroup,
                parseElementDirection,
                currentAdminRole,
                deleteMesocycle,
                deleteMicrocycle,
                deleteSeason
            }
        },

        components: {
            AddTrainingForm
        }
    }
</script>

<style lang="scss" scoped>

</style>


